import actionTypes from 'constants/actionTypes'
import type { Shape } from 'types/shapes'

export const addShape = (shape: Shape) => {
  return {
    type: actionTypes.SHAPES.ADD,
    payload: shape,
  }
}

export const removeShape = (id: string) => {
  return {
    type: actionTypes.SHAPES.REMOVE,
    payload: { id },
  }
}

export const updateShape = (id: string, updates: Partial<Omit<Shape, 'id'>>) => {
  return {
    type: actionTypes.SHAPES.UPDATE,
    payload: { id, ...updates },
  }
}
